const FromIdMap = {
    sendAppMessage: 3,
    shareTimeline: 4,
    sendGameNameCard: 5
};

const SharePositionID = {
    PAGE: 12,
    CUSTOM: 13,
};

const ShareActionID = {
    CLICK: 2,
    SENDAPPMESSAGE: 30,
    SENDTIMELINE: 31,
};

export {
    FromIdMap,
    SharePositionID,
    ShareActionID
}